import LazyLoad from 'react-lazyload';
import React from 'react';

export const IconDropsScienceMolecule = () => {
  return (
    <>
      <div className="hidden lg:block w-full">
        <LazyLoad offset={100}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 455.683 131"
            className="w-9/10 mx-auto mt-8"
          >
            <rect
              id="Rectangle_280"
              data-name="Rectangle 280"
              width="394"
              height="58"
              transform="translate(61.683)"
              fill="#0057b7"
            />
            <rect
              id="Rectangle_287"
              data-name="Rectangle 287"
              width="394"
              height="58"
              transform="translate(61.683 73)"
              fill="#0057b7"
            />
            <text
              id="Active_ingredients_-_Conium_maculatum_Natrum_muriaticum_Ruta_graveolens_Senega_officinalis"
              data-name="Active ingredients - Conium maculatum,  Natrum muriaticum, Ruta
graveolens, Senega officinalis"
              transform="translate(90.683 23.5)"
              fill="#fff"
              className="waldo-sans font-normal text-xs"
            >
              <tspan x="0" y="0">
                Active ingredients -{' '}
              </tspan>
              <tspan
                y="0"
                xmlSpace="preserve"
                className="waldo-sans font-light text-xs"
              >
                Conium maculatum, Natrum muriaticum, Ruta
              </tspan>
              <tspan className="waldo-sans font-light text-xs">
                <tspan x="0" y="16">
                  graveolens, Senega officinalis
                </tspan>
              </tspan>
            </text>
            <text
              id="Inactive_ingredients_-_Borate_buffer_Purified_water_Silver_sulfate_as_preservative_Sodium_nitrate"
              data-name="Inactive ingredients - Borate buffer,  Purified water, Silver sulfate
(as preservative), Sodium nitrate"
              transform="translate(90.683 97.5)"
              fill="#fff"
              className="waldo-sans font-normal text-xs"
            >
              <tspan x="0" y="0">
                Inactive ingredients -{' '}
              </tspan>
              <tspan
                y="0"
                xmlSpace="preserve"
                className="waldo-sans font-light text-xs"
              >
                Borate buffer, Purified water, Silver sulfate
              </tspan>
              <tspan className="waldo-sans font-light text-xs italic">
                <tspan x="0" y="16">
                  (as preservative)
                </tspan>
                <tspan
                  y="16"
                  className="waldo-sans font-light text-xs not-italic"
                >
                  , Sodium nitrate
                </tspan>
              </tspan>
            </text>
            <path
              id="Polygon_10"
              data-name="Polygon 10"
              d="M8,0l8,12H0Z"
              transform="translate(49.683 52) rotate(-90)"
              fill="#0057b7"
            />
            <path
              id="Polygon_12"
              data-name="Polygon 12"
              d="M8,0l8,12H0Z"
              transform="translate(49.683 125) rotate(-90)"
              fill="#0057b7"
            />
            <g
              id="Group_543"
              data-name="Group 543"
              transform="translate(-35.317 -6116)"
            >
              <g
                id="Group_541"
                data-name="Group 541"
                transform="translate(36 6166.557)"
              >
                <g id="g1777">
                  <g id="g1710" transform="translate(3.442 18.215)">
                    <path
                      id="path1706"
                      d="M222.843,148.268l8.6,4.967v9.935l-8.6,4.968-8.6-4.968v-9.935Z"
                      transform="translate(-214.239 -148.268)"
                      fill="none"
                      stroke="#ecbaa8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1"
                    />
                  </g>
                  <g id="g1723" transform="translate(20.65 18.215)">
                    <path
                      id="path1718"
                      d="M248.6,148.268l8.6,4.967v9.935l-8.6,4.968-8.6-4.968v-9.935Z"
                      transform="translate(-240 -148.268)"
                      fill="none"
                      stroke="#ecbaa8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1"
                    />
                  </g>
                  <g id="g1729" transform="translate(12.046 3.312)">
                    <path
                      id="path1725"
                      d="M235.724,125.958l8.6,4.967v9.936l-8.6,4.967-8.6-4.967v-9.936Z"
                      transform="translate(-227.119 -125.958)"
                      fill="none"
                      stroke="#ecbaa8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1"
                    />
                  </g>
                  <path
                    id="path1731"
                    d="M240,124.312V121"
                    transform="translate(-219.35 -121)"
                    fill="none"
                    stroke="#ecbaa8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                  />
                  <path
                    id="path1733"
                    d="M227.119,178.014v3.312"
                    transform="translate(-215.073 -139.928)"
                    fill="none"
                    stroke="#ecbaa8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                  />
                  <path
                    id="path1735"
                    d="M252.881,178.014v3.312"
                    transform="translate(-223.626 -139.928)"
                    fill="none"
                    stroke="#ecbaa8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                  />
                  <path
                    id="path1737"
                    d="M265.761,154.716l3.442-1.987"
                    transform="translate(-227.902 -131.534)"
                    fill="none"
                    stroke="#ecbaa8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                  />
                  <path
                    id="path1739"
                    d="M265.761,170.577l3.442,1.987"
                    transform="translate(-227.902 -137.459)"
                    fill="none"
                    stroke="#ecbaa8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                  />
                  <path
                    id="path1742"
                    d="M252.881,132.407l3.442-1.987"
                    transform="translate(-223.626 -124.127)"
                    fill="none"
                    stroke="#ecbaa8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                  />
                  <path
                    id="path1744"
                    d="M212.529,154.716l-3.442-1.987"
                    transform="translate(-209.087 -131.534)"
                    fill="none"
                    stroke="#ecbaa8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                  />
                  <path
                    id="path1746"
                    d="M212.529,170.577l-3.442,1.987"
                    transform="translate(-209.087 -137.459)"
                    fill="none"
                    stroke="#ecbaa8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                  />
                  <path
                    id="path1748"
                    d="M225.409,132.407l-3.442-1.987"
                    transform="translate(-213.363 -124.127)"
                    fill="none"
                    stroke="#ecbaa8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                  />
                </g>
                <g
                  id="g1723-2"
                  data-name="g1723"
                  transform="translate(12.046 33.527)"
                >
                  <path
                    id="path1718-2"
                    data-name="path1718"
                    d="M248.6,148.268l8.6,4.967v9.935l-8.6,4.968-8.6-4.968v-9.935Z"
                    transform="translate(-240 -148.268)"
                    fill="none"
                    stroke="#ecbaa8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                  />
                </g>
                <path
                  id="path1746-2"
                  data-name="path1746"
                  d="M212.529,170.577l-3.442,1.987"
                  transform="translate(-200.483 -122.459)"
                  fill="none"
                  stroke="#ecbaa8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                />
                <path
                  id="path1739-2"
                  data-name="path1739"
                  d="M265.761,170.577l3.442,1.987"
                  transform="translate(-236.507 -122.459)"
                  fill="none"
                  stroke="#ecbaa8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                />
              </g>
              <path
                id="Path_405"
                data-name="Path 405"
                d="M2991.65,4559.27v-9.838h23.787"
                transform="translate(-2935 1610.568)"
                fill="none"
                stroke="#ecbaa8"
                strokeWidth="1"
                strokeDasharray="1"
              />
              <path
                id="Path_406"
                data-name="Path 406"
                d="M2991.65,4619v13.045h23.787"
                transform="translate(-2935 1600.955)"
                fill="none"
                stroke="#ecbaa8"
                strokeWidth="1"
                strokeDasharray="1"
              />
            </g>
          </svg>
        </LazyLoad>
      </div>
      <div className="block lg:hidden">
        <LazyLoad offset={100}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-9/10 mx-auto mt-5 -mb-10"
            viewBox="0 0 343 207.25"
          >
            <g
              id="Group_632"
              data-name="Group 632"
              transform="translate(-16 -6092)"
            >
              <g
                id="Group_542"
                data-name="Group 542"
                transform="translate(0 -18)"
              >
                <rect
                  id="Rectangle_280"
                  data-name="Rectangle 280"
                  width="262"
                  height="70"
                  transform="translate(97 6110)"
                  fill="#0057b7"
                />
                <rect
                  id="Rectangle_281"
                  data-name="Rectangle 281"
                  width="262"
                  height="70"
                  transform="translate(97 6221)"
                  fill="#0057b7"
                />
                <text
                  id="Active_ingredients_-_Conium_maculatum_Natrum_muriaticum_Ruta_graveolens_Senega_officinalis"
                  data-name="Active ingredients - Conium maculatum, 
Natrum muriaticum, Ruta graveolens , 
Senega officinalis"
                  transform="translate(126 6133.5)"
                  fill="#fff"
                  className="waldo-sans font-normal text-xs"
                >
                  <tspan x="0" y="0">
                    Active ingredients -{' '}
                  </tspan>
                  <tspan y="0" className="waldo-sans font-light text-xs">
                    Conium maculatum,{' '}
                  </tspan>
                  <tspan className="waldo-sans font-light text-xs">
                    <tspan x="0" y="16">
                      Natrum muriaticum, Ruta graveolens ,{' '}
                    </tspan>
                    <tspan x="0" y="32">
                      Senega officinalis
                    </tspan>
                  </tspan>
                </text>
                <text
                  id="Inactive_ingredients_-_Borate_buffer_Purified_water_Silver_sulfate_as_preservative_Sodium_nitrate"
                  data-name="Inactive ingredients - Borate buffer, 
Purified water, Silver sulfate (as preservative),
Sodium nitrate"
                  transform="translate(126 6245)"
                  fill="#fff"
                  className="waldo-sans font-normal text-xs"
                >
                  <tspan x="0" y="0">
                    Inactive ingredients -{' '}
                  </tspan>
                  <tspan y="0" className="waldo-sans font-light text-xs">
                    Borate buffer,{' '}
                  </tspan>
                  <tspan className="waldo-sans font-light text-xs">
                    <tspan x="0" y="16">
                      Purified water, Silver sulfate{' '}
                    </tspan>
                    <tspan
                      y="16"
                      className="waldo-sans font-light text-xs italic"
                    >
                      (as preservative)
                    </tspan>
                    <tspan y="16">,</tspan>
                    <tspan
                      x="0"
                      y="32"
                      className="waldo-sans font-light text-xs not-italic"
                    >
                      Sodium nitrate
                    </tspan>
                  </tspan>
                </text>
                <path
                  id="Polygon_10"
                  data-name="Polygon 10"
                  d="M8,0l8,12H0Z"
                  transform="translate(85 6168) rotate(-90)"
                  fill="#0057b7"
                />
                <path
                  id="Polygon_11"
                  data-name="Polygon 11"
                  d="M8,0l8,12H0Z"
                  transform="translate(85 6280) rotate(-90)"
                  fill="#0057b7"
                />
              </g>
              <g
                id="Group_543"
                data-name="Group 543"
                transform="translate(0 -18)"
              >
                <g id="Group_541" data-name="Group 541">
                  <g id="g1777" transform="translate(-173.087 6058.602)">
                    <g id="g1710" transform="translate(212.529 139.215)">
                      <path
                        id="path1706"
                        d="M222.843,148.268l8.6,4.967v9.935l-8.6,4.968-8.6-4.968v-9.935Z"
                        transform="translate(-214.239 -148.268)"
                        fill="none"
                        stroke="#ecbaa8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                      />
                    </g>
                    <g id="g1723" transform="translate(229.737 139.215)">
                      <path
                        id="path1718"
                        d="M248.6,148.268l8.6,4.967v9.935l-8.6,4.968-8.6-4.968v-9.935Z"
                        transform="translate(-240 -148.268)"
                        fill="none"
                        stroke="#ecbaa8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                      />
                    </g>
                    <g id="g1729" transform="translate(221.133 124.312)">
                      <path
                        id="path1725"
                        d="M235.724,125.958l8.6,4.967v9.936l-8.6,4.967-8.6-4.967v-9.936Z"
                        transform="translate(-227.119 -125.958)"
                        fill="none"
                        stroke="#ecbaa8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                      />
                    </g>
                    <path
                      id="path1731"
                      d="M240,124.312V121"
                      transform="translate(-10.263 0)"
                      fill="none"
                      stroke="#ecbaa8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1"
                    />
                    <path
                      id="path1733"
                      d="M227.119,178.014v3.312"
                      transform="translate(-5.986 -18.928)"
                      fill="none"
                      stroke="#ecbaa8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1"
                    />
                    <path
                      id="path1735"
                      d="M252.881,178.014v3.312"
                      transform="translate(-14.539 -18.928)"
                      fill="none"
                      stroke="#ecbaa8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1"
                    />
                    <path
                      id="path1737"
                      d="M265.761,154.716l3.442-1.987"
                      transform="translate(-18.815 -10.534)"
                      fill="none"
                      stroke="#ecbaa8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1"
                    />
                    <path
                      id="path1739"
                      d="M265.761,170.577l3.442,1.987"
                      transform="translate(-18.815 -16.459)"
                      fill="none"
                      stroke="#ecbaa8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1"
                    />
                    <path
                      id="path1742"
                      d="M252.881,132.407l3.442-1.987"
                      transform="translate(-14.539 -3.127)"
                      fill="none"
                      stroke="#ecbaa8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1"
                    />
                    <path
                      id="path1744"
                      d="M212.529,154.716l-3.442-1.987"
                      transform="translate(0 -10.534)"
                      fill="none"
                      stroke="#ecbaa8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1"
                    />
                    <path
                      id="path1746"
                      d="M212.529,170.577l-3.442,1.987"
                      transform="translate(0 -16.459)"
                      fill="none"
                      stroke="#ecbaa8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1"
                    />
                    <path
                      id="path1748"
                      d="M225.409,132.407l-3.442-1.987"
                      transform="translate(-4.276 -3.127)"
                      fill="none"
                      stroke="#ecbaa8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1"
                    />
                  </g>
                  <g
                    id="g1723-2"
                    data-name="g1723"
                    transform="translate(48.046 6213.129)"
                  >
                    <path
                      id="path1718-2"
                      data-name="path1718"
                      d="M248.6,148.268l8.6,4.967v9.935l-8.6,4.968-8.6-4.968v-9.935Z"
                      transform="translate(-240 -148.268)"
                      fill="none"
                      stroke="#ecbaa8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1"
                    />
                  </g>
                  <path
                    id="path1746-2"
                    data-name="path1746"
                    d="M212.529,170.577l-3.442,1.987"
                    transform="translate(-164.483 6057.143)"
                    fill="none"
                    stroke="#ecbaa8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                  />
                  <path
                    id="path1739-2"
                    data-name="path1739"
                    d="M265.761,170.577l3.442,1.987"
                    transform="translate(-200.507 6057.143)"
                    fill="none"
                    stroke="#ecbaa8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                  />
                </g>
                <path
                  id="Path_405"
                  data-name="Path 405"
                  d="M2991.65,4569.034v-19.6h23.787"
                  transform="translate(-2935 1610.568)"
                  fill="none"
                  stroke="#ecbaa8"
                  strokeWidth="1"
                  strokeDasharray="1"
                />
                <path
                  id="Path_406"
                  data-name="Path 406"
                  d="M2991.65,4619v39h23.787"
                  transform="translate(-2935 1614)"
                  fill="none"
                  stroke="#ecbaa8"
                  strokeWidth="1"
                  strokeDasharray="1"
                />
              </g>
            </g>
          </svg>
        </LazyLoad>
      </div>
    </>
  );
};
